export default __webpack_public_path__ + "static/media/photos.9a5ddfb1.svg";